import { IProps } from "config/props";
import { darcieChatPanel } from "./darcie.chat.panel";
import { aliChatPanel } from "./ali.chat.panel";

const personalityMapping = {
  Darcie: [darcieChatPanel],
  Ali: [aliChatPanel],
};

export const getPanel = ({ personality }: IProps) => {
  return personalityMapping[personality];
};
